import { observer } from 'mobx-react-lite';
import { Dropdown } from 'antd';
import { useState } from 'react';
import { request } from '@/common';
import Other from '@/common/helper/other';
import { HelperCore } from '@/common/dependencies';
import { SVGPureIcon } from '@/ui';
import globalStore from '@/store/global';

const DOWNLOAD_ITEMS = [
  {
    key: 'ppt',
    label: '下载为PPTX',
  },
  {
    key: 'pdf',
    label: '下载为PDF',
  },
  {
    key: 'html',
    label: '下载为HTML',
  },
];

const Downloads = observer(({chatId="", msg_id=""}) => {
  const [isShowDownload, setIsShowDownload] = useState(false);
  const isSearch = location.pathname.startsWith("/sosearch");

  const handleDownloadFile = (export_type = 'html') => {
    setIsShowDownload(false);

    request
    .post(
      !isSearch ? '/ai_agent/msg/result/export' : '/gen_html/export?appsource=so',
      {
        conversation_id: chatId,
        msg_id,
        type: !isSearch ? 2 : 1,
        export_type,
      },
      { dataIsJson: true }
    )
    .then(res => {
      const { url = '' } = res?.data ?? {};
      const _fileName = `ppt-${chatId}-${msg_id}.zip`;
      HelperCore.saveFile(url, _fileName);
    })
    .catch(() => {
      Other.toast('下载失败，请重试', 'error');
    })
  };

  return (
    <Dropdown  
      dropdownRender={() => (
        <div className='flex flex-col w-132px h-136px bg-white rounded-12px p-8px shadow-2xl'>
          {DOWNLOAD_ITEMS.map(item => (
            <div
              key={item.key}
              className="w-116px h-40px px-8px py-13px rounded-6px cursor-pointer hover:bg-[#f7f7f7] text-black text-14px"
              onClick={() => handleDownloadFile(item.key)}
            >
              {item.label}
            </div>
          ))}
        </div>
      )} 
      placement="bottom"
      open={isShowDownload}
      onOpenChange={visible => setIsShowDownload(visible)}
      getPopupContainer={node => node}
    >
      <div>
        <SVGPureIcon
          name="full_screen_modal_download"
          className="size-28px cursor-pointer hover:bg-[#f7f7f7] rounded-6px"
        />
      </div>
    </Dropdown>
  )
})

export default Downloads